import * as React from 'react';
import _ from 'lodash';
import { setting } from '../components/pageComponents';
import EventManager, { EventType } from '../utilities/EventManager';
import urlParamManger from '../utilities/urlParamManager';
import { FieldItemInputService } from '../services/FieldItemInputs';
import { TouchDeviceInvisible } from '../components/TouchDeviceInvisible';
import { MasterPageHeader } from './PageHeader';

export class SettingMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageName: '',
      pageNumber: null,
      fieldId: sessionStorage.getItem('field_id'),
      itemNames: {},
      title: '',
    };
    this.settingMenuElement = React.createRef();

    // 棟・階・エリア・工区リストタイトル取得
    FieldItemInputService.itemNames(this.state.fieldId).then(itemNames =>
      this.setState({ itemNames })
    );
  }

  componentDidUpdate(prevProps, prevState) {
    // 設定ページが変更された時(titleが変わった時)

    // HTML element から取得できる現在選択されたタイトル
    const nowTitle = (() => {
      const selectedElements = this.settingMenuElement.current.getElementsByClassName(
        'line-list--setting-navi-list select'
      );
      if (selectedElements.length < 1) {
        return '';
      }
      if (_.isUndefined(selectedElements[0])) {
        return '';
      }
      return selectedElements[0].innerText;
    })();

    if (nowTitle !== prevState.title) {
      // タイトル(日本語名)が現在のタイトルとState上のtitleが異なる場合には値を更新する
      this.setState({ title: nowTitle });
    }

    // ブラウザバック時のみ動いてほしいために setTimeout にしている
    // これをいれないと、棟/階/エリア/工区 のブラウザバック時の読み込みが
    // なぜかうまくいかない。
    setTimeout(() => {
      // URLから選択しているページとページ番号を取得
      const { pageName, pageNumber } = this.getSelectedPageInfoFromUrl();

      const ConferenceSettingList = [
        'FieldImages', // 帳票用画像・その他資料
        'Keyplan', // キープラン
        'FieldItemInputs', // 項目設定
        'FieldAItems', // 作業場所1～4
        'WorkDates', // 稼働日設定
        'FieldApprovals', // 承認権限設定
        'PartnerCompaniesOrder', // 協力会社並び替え
        'GroupSetting', // グループ設定
        'Gates', // ゲート一覧
        'Cranes', // 揚重機一覧
        'Machineries', // 機材一覧
        'CranePrintSentences', //「揚重機・機材」帳票文言
        'TotalizeInfo', // 作業員集計の帳票項目
      ];
      if (!ConferenceSettingList.includes(pageName)) {
        return;
      }

      // 初期時の誤動作防止
      if (this.state.pageName === '') {
        this.setState({ pageName, pageNumber });
        return;
      }

      // ブラウザバック時のURLとStateの連動が取れていない場合に
      // loadPageでHistory記録なしで動作するようにする
      if (
        this.state.pageName !== pageName ||
        this.state.pageNumber !== pageNumber
      ) {
        this.loadPage(pageName, pageNumber, true);
      }
    }, 100);
  }

  /**
   * ページのロード
   * @param { string } pageName
   */
  loadPage(pageName, pageNumber = 1, noUseHistory = false) {
    this.props.loadSettingPage(setting[pageName], pageNumber);
    urlParamManger.setPageNumber(
      pageName,
      this.props.vw,
      pageNumber,
      noUseHistory
    );
    this.setState({ pageName, pageNumber });
    EventManager.trigger(EventType.LAYOUT_UPDATE, {});
  }

  // 現在のURLと、指定したページ名とページ番号が一致しているかどうかを判定する
  isSelected(pageName, pageNumber) {
    const url = window.location.href.split('/');
    const urlItem = url[url.length - (3 - this.props.vw)].split(':');
    let selected = false;
    if (pageNumber) {
      if (pageName === urlItem[0] && urlItem[1] == pageNumber) {
        selected = true;
      }
    } else {
      if (pageName === urlItem[0]) {
        selected = true;
      }
    }
    return selected;
  }

  // 現在のURLから、ページ名とページ番号を取得している
  getSelectedPageInfoFromUrl() {
    const url = window.location.href.split('/');
    const urlItem = url[url.length - (3 - this.props.vw)].split(':');
    return {
      pageName: urlItem[0],
      pageNumber: urlItem[1],
    };
  }

  render() {
    const itemSelected = (pageName, pageNumber) => {
      return this.isSelected(pageName, pageNumber)
        ? 'line-list line-list--setting-navi-list select'
        : 'line-list line-list--setting-navi-list';
    };

    return (
      <React.Fragment>
        <MasterPageHeader
          title={`各種設定 - ${this.state.title}`}
          disableHelpMenu
        />
        <div className='setting-main__sidemenu' ref={this.settingMenuElement}>
          <div id='setting-navi' className='setting-navi'>
            <ul className='setting-navi-list'>
              <li className='setting-navi-list__item'>
                <div
                  onClick={() => {
                    if (!this.isSelected('FieldImages')) {
                      this.loadPage('FieldImages');
                    }
                  }}
                  className={itemSelected('FieldImages')}
                >
                  <div className='icon icon--line-list'>
                    <i className='i-home' aria-hidden='true' />
                  </div>
                  帳票用画像・その他資料
                </div>
              </li>
              <li className='setting-navi-list__item'>
                <div
                  onClick={() => {
                    if (!this.isSelected('Keyplan')) {
                      this.loadPage('Keyplan');
                    }
                  }}
                  className={itemSelected('Keyplan')}
                >
                  <div className='icon icon--line-list'>
                    <i className='i-genbahaitizu' aria-hidden='true' />
                  </div>
                  キープラン
                </div>
              </li>
              <li className='setting-navi-list__item'>
                <div
                  onClick={() => {
                    if (!this.isSelected('FieldItemInputs')) {
                      this.loadPage('FieldItemInputs');
                    }
                  }}
                  className={itemSelected('FieldItemInputs')}
                >
                  <div className='icon icon--line-list'>
                    <i className='i-koumoku' aria-hidden='true' />
                  </div>
                  項目設定
                </div>
              </li>
              <li className='setting-navi-list__item'>
                <div
                  onClick={() => {
                    if (!this.isSelected('FieldAItems', 1)) {
                      this.loadPage('FieldAItems', 1);
                    }
                  }}
                  className={itemSelected('FieldAItems', 1)}
                >
                  <div className='icon icon--line-list'>
                    <i className='i-tou' aria-hidden='true' />
                  </div>
                  {this.state.itemNames.A}
                  {/* 棟 */}
                </div>
              </li>
              <li className='setting-navi-list__item'>
                <div
                  onClick={() => {
                    if (!this.isSelected('FieldAItems', 2)) {
                      this.loadPage('FieldAItems', 2);
                    }
                  }}
                  className={itemSelected('FieldAItems', 2)}
                >
                  <div className='icon icon--line-list'>
                    <i className='i-kai' aria-hidden='true' />
                  </div>
                  {this.state.itemNames.B}
                  {/* 階 */}
                </div>
              </li>
              <li className='setting-navi-list__item'>
                <div
                  onClick={() => {
                    if (!this.isSelected('FieldAItems', 3)) {
                      this.loadPage('FieldAItems', 3);
                    }
                  }}
                  className={itemSelected('FieldAItems', 3)}
                >
                  <div className='icon icon--line-list'>
                    <i className='i-area' aria-hidden='true' />
                  </div>
                  {this.state.itemNames.C}
                  {/* エリア */}
                </div>
              </li>
              <li className='setting-navi-list__item'>
                <div
                  onClick={() => {
                    if (!this.isSelected('FieldAItems', 4)) {
                      this.loadPage('FieldAItems', 4);
                    }
                  }}
                  className={itemSelected('FieldAItems', 4)}
                >
                  <div className='icon icon--line-list'>
                    <i className='i-kouku' aria-hidden='true' />
                  </div>
                  {this.state.itemNames.D}
                  {/* 工区 */}
                </div>
              </li>
              <li className='setting-navi-list__item'>
                <div
                  onClick={() => {
                    if (!this.isSelected('WorkDates')) {
                      this.loadPage('WorkDates');
                    }
                  }}
                  className={itemSelected('WorkDates')}
                >
                  <div className='icon icon--line-list'>
                    <i className='i-kadobi' aria-hidden='true' />
                  </div>
                  稼働日
                </div>
              </li>
              <li className='setting-navi-list__item'>
                <div
                  onClick={() => {
                    if (!this.isSelected('FieldApprovals')) {
                      this.loadPage('FieldApprovals');
                    }
                  }}
                  className={itemSelected('FieldApprovals')}
                >
                  <div className='icon icon--line-list'>
                    <i className='i-sekoutaikei' aria-hidden='true' />
                  </div>
                  承認権限設定
                </div>
              </li>
              <TouchDeviceInvisible>
                <li className='setting-navi-list__item'>
                  <div
                    onClick={() => {
                      if (!this.isSelected('PartnerCompaniesOrder')) {
                        this.loadPage('PartnerCompaniesOrder');
                      }
                    }}
                    className={itemSelected('PartnerCompaniesOrder')}
                  >
                    <div className='icon icon--line-list'>
                      <i className='i-sekoutaikei' aria-hidden='true' />
                    </div>
                    協力会社並び順
                  </div>
                </li>
              </TouchDeviceInvisible>
              {/* TODO: 作成中 */}
              <li className='setting-navi-list__item'>
                <div
                  onClick={() => {
                    if (!this.isSelected('GroupSetting')) {
                      this.loadPage('GroupSetting');
                    }
                  }}
                  className={itemSelected('GroupSetting')}
                >
                  <div className='icon icon--line-list'>
                    <i className='i-sekoutaikei' aria-hidden='true' />
                  </div>
                  グループ設定
                </div>
              </li>
              <li className='setting-navi-list__item'>
                <div
                  onClick={() => {
                    if (!this.isSelected('Gates')) {
                      this.loadPage('Gates');
                    }
                  }}
                  className={itemSelected('Gates')}
                >
                  <div className='icon icon--line-list'>
                    <i className='i-gate' aria-hidden='true' />
                  </div>
                  ゲート一覧
                </div>
              </li>
              <li className='setting-navi-list__item'>
                <div
                  onClick={() => {
                    if (!this.isSelected('Cranes')) {
                      this.loadPage('Cranes');
                    }
                  }}
                  className={itemSelected('Cranes')}
                >
                  <div className='icon icon--line-list'>
                    <i className='i-jyuuki' aria-hidden='true' />
                  </div>
                  揚重機一覧
                </div>
              </li>
              <li className='setting-navi-list__item'>
                <div
                  onClick={() => {
                    if (!this.isSelected('Machineries')) {
                      this.loadPage('Machineries');
                    }
                  }}
                  className={itemSelected('Machineries')}
                >
                  <div className='icon icon--line-list'>
                    <i className='i-kizai' aria-hidden='true' />
                  </div>
                  機材一覧
                </div>
              </li>
              <li className='setting-navi-list__item'>
                <div
                  onClick={() => {
                    if (!this.isSelected('CranePrintSentences')) {
                      this.loadPage('CranePrintSentences');
                    }
                  }}
                  className={itemSelected('CranePrintSentences')}
                >
                  <div className='icon icon--line-list'>
                    <i className='i-insatsu' aria-hidden='true' />
                  </div>
                  揚重機・機材の帳票文言
                </div>
              </li>
              <li className='setting-navi-list__item'>
                <div
                  onClick={() => {
                    if (!this.isSelected('TotalizeInfo')) {
                      this.loadPage('TotalizeInfo');
                    }
                  }}
                  className={itemSelected('TotalizeInfo')}
                >
                  <div className='icon icon--line-list'>
                    <i className='i-insatsu' aria-hidden='true' />
                  </div>
                  作業員集計の帳票項目
                </div>
              </li>
            </ul>
          </div>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SettingMenu.jsx